<template>
    <div>
        <el-input v-model="token"></el-input>
        <el-button type="primary"
                   @click="doLogin">
            本地登录测试
        </el-button>
    </div>
</template>
<script>
export default {
    data () {
        return {
            token: ''
        };
    },
    methods: {
        async doLogin () {
            let resp;
            resp = await this.axios({
                url: '/login',
                method: 'GET',
                params: { access_token: this.token }
            });
            resp = resp.data;
            this.$store.dispatch('initQuser', { QID: resp.token });
            this.$router.push('/home');
        }
    }
};
</script>